/**
 * RNC — Retail Notifications Center module entry.
 * See `./routes.tsx` + `./RncDashboard.tsx`.
 */
import './rnc.css';
import { RncRoutes } from './routes';

export default function RNC(): JSX.Element {
  return <RncRoutes />;
}
